<template>
  <v-container class="events v-step-0">
    <v-container fluid class="pa-0 ma-0">
      <v-img fill max-height="25vh" :src="event.header" />
    </v-container>
    <v-container class="pa-6 pt-10" fluid>
      <v-row>
        <v-col cols="6">
          <h1 class="pl-4 ma-0 h1">{{ event.name }}</h1>
          <p class="pl-4 ma-0">{{ event.dates }}</p>
        </v-col>
        <v-col cols="6" class="text-right">
          <v-btn @click="editGame()"> {{ $t("Edit Game") }}</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="services-list">
      <v-row dense>
        <!-- manage teams -->
        <v-col cols="12" class="col-md-4 v-step-1">
          <v-card class="pa-0">
            <v-card-text>
              <v-row>
                <v-col
                  cols="3"
                  class="d-flex flex-no-wrap align-center justify-center"
                >
                  <v-img contain src="./assets/teams.svg"></v-img>
                </v-col>
                <v-col cols="9">
                  <v-card-title>{{ $t("Manage Team") }}</v-card-title>
                  <v-spacer></v-spacer>
                  <v-card-subtitle>
                    {{ $t("Upload Team") }}<br />
                    {{ $t("Manage Activation Status") }} <br />
                    {{ $t("Manage Team Profile Data") }}<br />
                  </v-card-subtitle>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <router-link :to="'/games/about/' + 1">
                <v-btn icon>
                  <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
              </router-link>
            </v-card-actions>
          </v-card>
        </v-col>

        <!-- About -->
        <v-col cols="12" class="col-md-4">
          <v-card class="pa-0">
            <v-card-text>
              <v-row>
                <v-col
                  cols="3"
                  class="d-flex flex-no-wrap align-center justify-center"
                >
                  <v-img contain src="./assets/rings.svg"></v-img>
                </v-col>
                <v-col cols="9">
                  <v-card-title>{{ $t("About the Games") }}</v-card-title>
                  <v-spacer></v-spacer>
                  <v-card-subtitle>
                    {{ $t("Upload Team") }}<br />
                    {{ $t("Manage Activation Status") }} <br />
                    {{ $t("Manage Team Profile Data") }}<br />
                  </v-card-subtitle>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <router-link :to="'/games/about/' + this.$route.params.id">
                <v-btn icon>
                  <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
              </router-link>
            </v-card-actions>
          </v-card>
        </v-col>

        <!-- Services -->
        <v-col cols="12" class="col-md-4">
          <v-card class="pa-0">
            <v-card-text>
              <v-row>
                <v-col
                  cols="3"
                  class="d-flex flex-no-wrap align-center justify-center"
                >
                  <v-img contain src="./assets/services.svg"></v-img>
                </v-col>
                <v-col cols="9">
                  <v-card-title>{{ $t("Services") }}</v-card-title>
                  <v-spacer></v-spacer>
                  <v-card-subtitle>
                    {{ $t("Access Forms Page to manage custom services") }}
                  </v-card-subtitle>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <router-link to="/game/1">
                <v-btn icon>
                  <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
              </router-link>
            </v-card-actions>
          </v-card>
        </v-col>

        <!-- Experience -->
        <v-col cols="12" class="col-md-4">
          <v-card class="pa-0">
            <v-card-text>
              <v-row>
                <v-col
                  cols="3"
                  class="d-flex flex-no-wrap align-center justify-center"
                >
                  <v-img contain src="./assets/experience.svg"></v-img>
                </v-col>
                <v-col cols="9">
                  <v-card-title>{{
                    $t("Prepare for Experience")
                  }}</v-card-title>
                  <v-spacer></v-spacer>
                  <v-card-subtitle>
                    {{ $t("Opens Pop-up with multiple choice navigation") }}
                  </v-card-subtitle>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <router-link :to="'/games/experience/' + this.$route.params.id">
                <v-btn icon>
                  <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
              </router-link>
            </v-card-actions>
          </v-card>
        </v-col>

        <!-- Calendar -->
        <v-col cols="12" class="col-md-4">
          <v-card class="pa-0">
            <v-card-text>
              <v-row>
                <v-col
                  cols="3"
                  class="d-flex flex-no-wrap align-center justify-center"
                >
                  <v-img contain src="./assets/calendar.svg"></v-img>
                </v-col>
                <v-col cols="9">
                  <v-card-title>{{ $t("Calendar") }}</v-card-title>
                  <v-spacer></v-spacer>
                  <v-card-subtitle>
                    {{ $t("Opens Pop-up with multiple choice navigation") }}
                  </v-card-subtitle>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- <router-link :to="'/calendar/' + this.$route.params.id"> -->
              <router-link :to="'/calendar/' + this.$route.params.id">
                <v-btn icon>
                  <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
              </router-link>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-navigation-drawer v-model="drawer" right>
      <v-container fluid class="py-10">
        <v-row>
          <v-col cols="12" class="align-center">
            <v-card elevation="0" class="px-5">
              <v-row>
                <v-col cols="6" class="align-center">
                  <v-text-field
                    label="Name"
                    v-model="event.name"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="align-center">
                  <v-text-field
                    label="Dates"
                    v-model="event.dates"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="align-center">
                  <h3 class="pt-5 ma-0 grey--text text--lightend-5">Banner</h3>
                  <MediaPopUp />
                  <v-img :src="event.header" height="25vh" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="d-flex justify-end">
                  <v-col class="text-right">
                    <v-btn color="green lighten-2" text @click="saveGame">
                      Ok
                    </v-btn>
                    <v-btn color="red lighten-2" text @click="reset">
                      Cancel
                    </v-btn>
                  </v-col>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>

    <tours :steps="steps" />
  </v-container>
</template>

<script>
import { firebaseApp } from "@/config/firebase";
import firebase from "firebase/app";
const db = firebase.firestore(firebaseApp);
import EventBus from "../../config/eventBus";
import gameProvider from "@/modules/Games/data/games";

export default {
  name: "GameSingle",
  route: {
    path: "/games/:id",
    name: "Specific Game",
  },
  data: () => ({
    drawer: false,
    event: {
      name: "",
      dates: "",
      header: "",
      edit: false,
    },
    steps: [
      {
        target: ".v-step-0", // We're using document.querySelector() under the hood
        header: {
          title: "frame 1",
        },
        content: `target element: .v-step-0`,
      },
      {
        target: ".v-step-1", // We're using document.querySelector() under the hood
        header: {
          title: "frame 2",
        },
        content: `target element: .v-step-1, content`,
      },
    ],
  }),
  components: {
    MediaPopUp: () =>
      import("../../components/MediaUploader/MediaSelector.vue"),
  },

  beforeMount() {
    this.getEvents();
  },
  mounted() {
    let self = this;
    EventBus.$on("IMAGE_PICKED", function (payLoad) {
      self.event.header = payLoad.url;
    });
  },
  unmounted() {
    EventBus.$off("IMAGE_PICKED");
  },

  methods: {
    editGame() {
      this.drawer = true;
    },
    async saveGame() {
      let self = this;
      gameProvider.editSingleGame(this.$route.params.id, this.event).then(function (event) {
        self.event = event;
        self.drawer = false;
      });
    },
    reset() {
      this.drawer = false;
      this.getEvents();
    },
    async getEvents() {
      let self = this;
      gameProvider.getEvent(this.$route.params.id).then(function (event) {
        self.event = event;
      });
    },
  },
};
</script>

<style lang="scss">
.events {
  .v-navigation-drawer {
    position: fixed;
    width: 70% !important;
  }
  .v-overlay--active {
    position: fixed;
  }
  .drawer-card {
    height: 100%;
    padding: 10%;
  }
}
</style>
